// `/dancers` index — the profile pane with nothing selected.

import { createFileRoute } from '@tanstack/react-router';

import { ProfileRestingState } from '~/bounded-contexts/roster/ui/dancers-page/profile-resting-state';

export const Route = createFileRoute('/_authenticated/dancers/')({
	component: ProfileRestingState,
});
